import { Store as VuexStore } from 'vuex';
import { NavigationGuard } from 'vue-router';

import { Store } from '@/store';
import { getNavigationGuardByScenarios } from '@/router/redirectingRules';
import {
  redirectToBuildingsListIfUserIsLoggedInScenario,
  redirectToOrganizationDetailsIfUserDidNotSetThemYet,
  redirectToLoginIfUserIsNotLoggedInScenario,
  redirectToBuildingsListIfUserDidNotSelectBuilding,
  redirectToLoginIfUserNotAuthorizedForOauth,
  redirectToOrganizationDetailsIfUserHasNoOneForOauth,
  redirectToBuildingIfBuildingIsSelected,
  redirectToBuildingStructurePageIfUserDidNotEnableScenarioFeature,
} from '@/router/helpers/scenarios';

export function redirectToBuildingsListOrBuildingIfUserIsLoggedInNavigationGuard(
  store: VuexStore<Store>,
): NavigationGuard {
  return getNavigationGuardByScenarios([
    redirectToBuildingIfBuildingIsSelected,
    redirectToBuildingsListIfUserIsLoggedInScenario,
  ], store);
}

export function redirectToBuildingsListIfUserIsLoggedInNavigationGuard(
  store: VuexStore<Store>,
): NavigationGuard {
  return getNavigationGuardByScenarios([
    redirectToBuildingsListIfUserIsLoggedInScenario,
  ], store);
}

export function validateUserIsLoggedIn(
  store: VuexStore<Store>,
): NavigationGuard {
  return getNavigationGuardByScenarios([
    redirectToLoginIfUserIsNotLoggedInScenario,
  ], store);
}

export function validateUserIsLoggedInAndIsInOrganization(
  store: VuexStore<Store>,
): NavigationGuard {
  return getNavigationGuardByScenarios([
    redirectToLoginIfUserIsNotLoggedInScenario,
    redirectToOrganizationDetailsIfUserDidNotSetThemYet,
  ], store);
}

export function validateUserIsLoggedInIsInOrganizationAndSelectedBuilding(
  store: VuexStore<Store>,
): NavigationGuard {
  return getNavigationGuardByScenarios([
    redirectToLoginIfUserIsNotLoggedInScenario,
    redirectToOrganizationDetailsIfUserDidNotSetThemYet,
    redirectToBuildingsListIfUserDidNotSelectBuilding,
  ], store);
}

export function validateUserIsLoggedInIsInOrganizationForAuth(
  store: VuexStore<Store>,
): NavigationGuard {
  return getNavigationGuardByScenarios([
    redirectToLoginIfUserNotAuthorizedForOauth,
    redirectToOrganizationDetailsIfUserHasNoOneForOauth,
  ], store);
}

export function validateUserIsEnabledScenarioFeature(
  store: VuexStore<Store>,
): NavigationGuard {
  return getNavigationGuardByScenarios([
    redirectToLoginIfUserIsNotLoggedInScenario,
    redirectToOrganizationDetailsIfUserDidNotSetThemYet,
    redirectToBuildingsListIfUserDidNotSelectBuilding,
    redirectToBuildingStructurePageIfUserDidNotEnableScenarioFeature,
  ], store);
}
